module.exports = ":host {\n  display: block; }\n\n.plr-dashboard {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1; }\n\n.plr-dashboard-content {\n    width: 100%;\n    position: relative;\n    margin-top: 12px;\n    margin-bottom: 24px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pillar/dashboard/components/dashboard.component.scss
// module id = ./src/app/pillar/dashboard/components/dashboard.component.scss
// module chunks = main